export const Status = [
  {
    _id: 0,
    title: "PENDING",
  },
  {
    _id: 1,
    title: "CANCELLED",
  },
  {
    _id: 2,
    title: "FAILED",
  },
  {
    _id: 3,
    title: "COMPLETED",
  },
];
